import create from "zustand";
import useDiscountState from "./discountState";

export type CurrentUserOverviewType = {
    id: number;
    likedRecipesId: number[];
    boughtCoursesId: number[];
    realBoughtCoursesId: number[];
    uuid: string;
    abo: boolean;

    aboUntil?: string;
    aboBufferUntil?: string;
    aboState?: "former-shared"|"shared"|"active-ios"|"active-android"|"cancel"|"active"|"byVoucher"|"former"|"missingPayment"|"lifetime"|"failedPayment";
    aboType?: "basic" | "premium" | "duo" | "family" | "shared";
    futureAboType?: "basic" | "premium" | "duo" | "family" | "shared";

    vat?: number;
    country?: string;

    // upgrade
    canUpgrade: boolean;
    upgradePriceReduction?: number;
    upgradeRemainingDays?: number;
    lastBuyByVoucher?: boolean;

    firstname?: string;
    lastname?: string;
    mail?: string;
    pinnedCourses: string[];
    nutrition?: string;
    city?: string;
    postcode?: string;
    street?: string;

    canRenewAbo: boolean;
    trialPeriod: number;
    customAboPrice?: number;
    lastReceiptDate?: string;

    aboCustomDiscountCode?: string;
    aboCustomDiscountCodeDays?: number;
    aboCustomDiscountCodeDate?: string;

    aboIsBuffer: boolean;

    hasFutureSubscription: boolean;
    expoPushTokens: string[];
    internal: boolean;

    sharedOwner: string;
    sharedAboState: string;

    braintreeSubscriptionId: string;
    stripeSubscriptionId: string;

    canUpgradeDuo: boolean;
    canUpgradeFamily: boolean;

}

interface AuthState {
    isInternal: boolean;
    showAboFamilyTeasers: boolean;
    setShowAboFamilyTeasers: (showAboFamilyTeasers: boolean) => void;
    currentUserOverview: CurrentUserOverviewType;
    setCurrentUserOverview: (c) => void;

    idToken: string;
    setIdToken: (idToken: string) => void;
}

const useAuthState = create<AuthState>(
    (set, get) => ({

        idToken: null,
        setIdToken: (idToken: string) => {
            set( { idToken } );
        },

        isInternal: false,

        showAboFamilyTeasers: false,

        /* TODO: try to add check for the testusers with DUO */
        setShowAboFamilyTeasers: (showAboFamilyTeasers) => {
            set({ showAboFamilyTeasers } );

            const blackFridayDate = new Date();
            blackFridayDate.setDate(25);
            blackFridayDate.setMonth(10);
            blackFridayDate.setFullYear(2023);

            const currentUserOverview = get().currentUserOverview;
            const aboUntil = new Date(currentUserOverview?.aboUntil)

            let newAboUser = false;

            if(aboUntil >= blackFridayDate){
                newAboUser = true;
            }

            if( newAboUser || (currentUserOverview?.customAboPrice === 119 && (currentUserOverview?.id % 10 === 0))){
                set( { showAboFamilyTeasers: true} );
            }
        },

        currentUserOverview: null,
        setCurrentUserOverview: (currentUserOverview) => {
            set( { currentUserOverview } );

            if (currentUserOverview?.internal) {
                set( { isInternal: true } );
            } else {
                set( { isInternal: false } );
            }

            if (currentUserOverview?.setShowAboFamilyTeasers) {
                get().setShowAboFamilyTeasers(true);
            }

        }
    })
);

export default useAuthState;
